export function validateTeamCreation(team, photoToUpload) {
  const errors = []

  if (!team.teamName) {
    errors.push('The team name cannot be blank')
  }

  return errors
}
